import React, { useState } from "react";
import './BackToTop.css';
import ArrowVector from '../../assets/Vector 7.svg';

const BackToTop = () => {
  const [isVisible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.body.scrollTop;

    if (scrolled > 1100) {
      setVisible(true);
    } else if (scrolled <= 1100) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  };

  window.addEventListener('scroll', toggleVisible);

  return <>
      <div className="btt" style={{display: isVisible ? null : 'none'}} onClick={scrollToTop}>
        <img alt="Go back to the top" src={ArrowVector} style={{transform: "rotate(90deg)", position: "fixed", right:"45px"}}/>
      </div>
  </>;
};

export default BackToTop;